import {
  Module, VuexModule, Action, getModule, Mutation,
} from "vuex-module-decorators";
import { SystemService } from "@/api/system-service";
import store from "@/store/store";

export interface InfoState {
  info: string;
}

@Module({
  dynamic: true, store, name: "info", namespaced: true,
})
class Info extends VuexModule implements InfoState {
  info = "";

  @Mutation
  public SET_INFO(info: string): void {
    this.info = info;
  }

  @Action({})
  public async fetch(): Promise<void> {
    const info = await SystemService.getInfo();

    this.SET_INFO(info);
  }
}

export const infoModule: Info = getModule(Info);
